export default function checkOrganization(organizationUuid) {
  if (organizationUuid && organizationUuid) {
    return `?organization_uuid=${organizationUuid}`;
  }

  return '';
}
